import React, {useRef} from "react";
import AttachmentFileList from "./AttachmentFileList";
import AttachmentListUploader from "./AttachmentListUploader";
import {AttachmentContainer, AttachmentLane} from "./AttachmentContainer";
import {appendDocFiles} from "./createAttachHelpers";

export default function CreateAttachPanel({docs, setDocs}) {
    const docIdRef = useRef(0);

    const handleDocInput = (e) => {
        setDocs((prev) => appendDocFiles(prev, e.target.files, docIdRef));
        e.target.value = "";
    };

    const listItems = docs.map((f) => ({
        id: f.id,
        originalName: f.originalName || f.object?.name || "파일",
    }));

    return (
        <AttachmentContainer>
            <AttachmentLane label="파일" variant="file" count={listItems.length}>
                <AttachmentListUploader
                    inputId="create_asset_doc"
                    onInputChange={handleDocInput}
                    hasFiles={listItems.length > 0}
                    fileList={
                        <AttachmentFileList
                            items={listItems}
                            onRemove={(item) => setDocs((prev) => prev.filter((f) => f.id !== item.id))}
                        />
                    }
                />
            </AttachmentLane>
        </AttachmentContainer>
    );
}
